'use client'

import { type Locale, translate } from '@shared/config/i18n'
import { openConfirmDialog } from '@shared/ui'
import React from 'react'

import { Button, ConfirmDialogV1Description, ConfirmDialogV1Title, Typography } from '@podo-app/design-system-temp'

export const openBlockConfirmDialog = ({
  tutorName,
  onConfirm,
  locale = 'ko',
}: {
  tutorName: string
  onConfirm: () => void
  locale?: Locale
}) => {
  const t = (key: string, values?: Record<string, string | number>) => translate(locale, key, values)

  openConfirmDialog({
    ConfirmHeader: () => (
      <>
        <ConfirmDialogV1Title>
          <Typography size="h3" className="font-bold text-center">
            {t('tutorExclusion.dialog.blockTitle', { tutorName })}
          </Typography>
        </ConfirmDialogV1Title>
        <ConfirmDialogV1Description>
          <Typography size="body2" className="text-gray-500 text-center">
            {t('tutorExclusion.dialog.blockDescription')}
          </Typography>
        </ConfirmDialogV1Description>
      </>
    ),
    ConfirmFooter: ({ handleClose }) => (
      <React.Fragment>
        <Button variant="ghost" size="xLarge" fullWidth onClick={handleClose} data-testid="btn-block-cancel">
          {t('common.actions.cancel')}
        </Button>
        <Button
          variant="primary"
          size="xLarge"
          fullWidth
          onClick={() => {
            onConfirm()
            handleClose()
          }}
          data-testid="btn-block-confirm"
        >
          {t('tutorExclusion.dialog.blockConfirm')}
        </Button>
      </React.Fragment>
    ),
  })
}
